<app-back-button routerLink="/admin"></app-back-button>
<div class="flex justify-end">
  <app-confirm-dialog
    [show]="showConfirmDialog"
    [message]="message"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
  ></app-confirm-dialog>
  <app-button (click)="openModal()">Adicionar</app-button>
  <app-modal [show]="showModal" (close)="closeModal()" title="Registrar Usuário">
    <form [formGroup]="userRegister" class="grid grid-cols-2 gap-3 mb-3 w-[800px]">
      <!-- <app-input formControlName="name" placeholder="Nome"></app-input> -->
      <app-input formControlName="email" placeholder="Email"></app-input>
      <app-input formControlName="password" placeholder="Senha" type="password"></app-input>

      <app-select formControlName="role" placeholder="Role" [options]="optionsRole"></app-select>
      @if (userRegister.value.role == 0) {
      <app-select
        formControlName="merchantId"
        placeholder="Estabelecimento"
        [options]="merchantOptions"
      ></app-select>
      }

      <app-multi-select
        formControlName="requiredActions"
        placeholder="Ações"
        [options]="multiSelectOptions"
      ></app-multi-select>
    </form>

    <div class="flex justify-end">
      <app-button (click)="salvar()">Salvar</app-button>
    </div>
  </app-modal>
</div>
<app-loading [show]="loading"></app-loading>
<app-table [columns]="columns" [data]="data"></app-table>
